module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_3_m2.353719a5ea854660b1b7828a4aba3de0.png";